<template lang="pug">
.bussiness-container
  .bussiness-top
    .bussiness-img
      img(:src="tempObj.businessLineIcon")
    .business-font {{tempObj.businessLineName}}
    template(v-if="busCoupons && busCoupons.length === 1")
      .business-total
        div 累计
        .red-font {{info.amount}}
        div 元
  LifeCardBussinessCoupons(
      v-for="(item, index) in busCoupons"
      :coupons="item.coupons"
      :ladderNum="item.ladderNum"
      :tempObj="tempObj"
      :key="index"
      )
</template>
<script>
import LifeCardBussinessCoupons from './life-card-bussiness-coupons.vue';
import { groupByLadderNum } from '../utils';

export default {
  components: {
    LifeCardBussinessCoupons,
  },
  props: {
    info: {
      type: Object,
      required: true,
    },
    ladderDetailMap: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cardList: [],
      tempObj: {},
      busCoupons: [],
    };
  },
  computed: {
  },
  watch: {
    info: {
      handler() {
        this.getInfo();
        this.handleCoupons();
      },
      immediate: true,
      deep: true,
    },

  },
  inject: ['getPropVersion'],
  methods: {
    handleCoupons() {
      this.busCoupons = groupByLadderNum(this.info.coupons, this.getPropVersion());
    },
    getInfo() {
      const valuesList = Object.values(this.ladderDetailMap);
      // eslint-disable-next-line no-restricted-syntax
      for (const i of valuesList) {
        if (i.ladderMarsCode === this.info.groupCode) {
          this.tempObj = i;
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bussiness-container {
  width: 100%;
  // height: 1.45rem;
  background: #fff9f0;
  border-radius: 0.12rem;
  padding-bottom: 0.12rem;

  .bussiness-top {
    display: flex;
    padding: 0.1rem 0.1rem 0.05rem 0.1rem;

    .bussiness-img {
      img {
        height: 0.2rem;
        object-fit: contain;
      }
    }

    .business-font {
      margin-left: 0.02rem;
      font-size: 0.14rem;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #531900;
    }

    .business-total {
      display: flex;
      margin-left: 0.08rem;
      font-size: 0.13rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #531900;

      .red-font {
        color: #fa4614;
      }
    }
  }
}
</style>
